// Styles for TermsOfUse go here.
import styled from 'styled-components';

export const StyledTermsOfUse = styled.div`
  a {
    word-wrap: break-word;
  }
`;
